import React from "react";
import { Menu, Layout, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useStateGlobalContext } from "../../../../contexts/GlobalContext";
import { useUnsavedLabs } from "../../../../contexts/UnsavedLabsContext";
import "../../../../styles/unsaved-labs-modal.css";

const { Content } = Layout;

const items = [
  {
    label: "Summary",
    key: "",
    role: ["clinic", "manager", "nurse", "doctor"],
  },
  {
    label: "Visits",
    key: "visits",
    role: ["clinic", "manager", "nurse", "doctor", "biller"],
  },
  {
    label: "General Notes",
    key: "general-notes",
    role: ["clinic", "manager", "nurse", "doctor", "biller"],
  },
  {
    label: "Medications",
    key: "medications",
    role: ["clinic", "manager", "nurse", "doctor", "biller"],
  },
  {
    label: "Lab & Imaging",
    key: "labs&imaging",
    role: ["clinic", "manager", "nurse", "doctor", "biller"],
  },
  {
    label: "Invoice & Billing",
    key: "invoice&billing",
    role: ["clinic", "manager", "nurse", "doctor", "biller"],
  },
  {
    label: "Memberships",
    key: "memberships",
    role: ["clinic", "manager", "nurse", "doctor"],
  },
  {
    label: "Patient Portal",
    key: "patient-portal",
    role: ["clinic", "manager", "nurse", "doctor"],
  },
  {
    label: "Referral",
    key: "patient-referral",
    role: ["clinic", "manager", "nurse", "doctor", "biller"],
  },
  {
    label: "Files",
    key: "patient-files",
    role: ["clinic", "manager", "nurse", "doctor", "biller"],
  },
  {
    label: "Insurances",
    key: "insurances",
    role: ["clinic", "manager", "nurse", "doctor", "biller"],
  },
  {
    label: "Profile",
    key: "profile",
    role: ["clinic", "manager", "nurse", "doctor", "biller"],
  },
];

const LABS_IMAGING_KEY = "labs&imaging";

const PatientTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { officeSetting, profile } = useStateGlobalContext();
  const unsavedLabs = useUnsavedLabs();
  const hasUnsavedLabs =
    (unsavedLabs?.hasUnsavedInhouseLabs ?? false) ||
    (unsavedLabs?.hasUnsavedExternalLabs ?? false);

  const officeDateFormat = officeSetting?.date_format;
  const officeTimeFormat = officeSetting?.time_format;
  const officeTimezone = officeSetting?.facility_time_zone;
  const role = profile && profile?.user_info[0]?.role;

  const filteredMenuItems = items.filter(item => item.role.includes(role));

  // Extract the last segment of the URL
  const lastPathSegment = location.pathname.split("/").filter(Boolean).pop();

  const handleMenuClick = (key) => {
    if (key === lastPathSegment) return;
    if (lastPathSegment === LABS_IMAGING_KEY && hasUnsavedLabs) {
      Modal.confirm({
        icon: (
          <ExclamationCircleOutlined
            style={{ color: "#faad14", fontSize: 22 }}
          />
        ),
        title: (
          <span style={{ fontWeight: 600, fontSize: 16 }}>
            You have unsaved changes
          </span>
        ),
        content: (
          <p style={{ margin: 0, color: "#595959", lineHeight: 1.6 }}>
            Your lab form or list has data that hasn’t been saved. If you leave
            now, this data will be lost. Would you like to stay and save, or
            leave anyway?
          </p>
        ),
        okText: "Leave",
        cancelText: "Stay",
        onOk: () => navigate(key),
        okButtonProps: {
          type: "primary",
        },
        cancelButtonProps: {
          style: {
            background: "#8c8c8c",
            borderColor: "#8c8c8c",
          },
        },
        className: "patient-tabs-unsaved-modal",
        centered: true,
      });
      return;
    }
    navigate(key);
  };

  return (
    <Layout style={{ backgroundColor: "transparent" }}>
      <Menu
        onClick={({ key }) => handleMenuClick(key)}
        mode="horizontal"
        selectedKeys={[lastPathSegment]} // Set the last path segment as the selected key
        items={filteredMenuItems}
        className="summary-menu mb-4 bg-white font-medium tracking-[0.2px]"
      />
      <Content
        className="layout"
        style={{
          backgroundColor: "white",
        }}
      >
        <Outlet
          context={[officeDateFormat, officeTimeFormat, officeTimezone]}
        />
      </Content>
    </Layout>
  );
};

export default PatientTabs;
